module.exports = __webpack_public_path__ + "static/media/excited_cloud.cddc2fd2.svg";